import type { MatcherLocation } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/types.tsx';

export const matchVirtualAgentPathname =
	() => (currentLocation: MatcherLocation, _: MatcherLocation) =>
		currentLocation.pathname.includes('settings/virtual-agent');
